/**
 * The CorkLog mark: one bottle, and the brass of its foil capsule.
 *
 * The same drawing as `public/favicon.svg`, without that file's tile and shelf
 * runner — in the header there is already a surface and a rule, and a second
 * tile stamped on top of them would be a badge where a letterform is enough.
 * The glass takes `currentColor`, so the mark dims and brightens with the
 * wordmark beside it instead of being a third colour in the header; the
 * capsule keeps the accent, because the brass is the point.
 *
 * The viewBox is cropped to the drawing rather than left at the tile's 32×32,
 * so the mark sizes against the text next to it and not against empty air.
 */
export function Mark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="10.8 2.5 10.4 25.4"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <path
        d="M14.3 4.4 V10.6 C14.3 12 13.9 12.7 13.1 13.5 C11.9 14.8 11.3 15.6 11.3 17.4 V26 C11.3 26.8 11.9 27.4 12.6 27.4 H19.4 C20.1 27.4 20.7 26.8 20.7 26 V17.4 C20.7 15.6 20.1 14.8 18.9 13.5 C18.1 12.7 17.7 12 17.7 10.6 V4.4 Z"
        fill="currentColor"
      />
      <rect
        x="13.7"
        y="3"
        width="4.6"
        height="3.9"
        rx="0.9"
        fill="var(--ck-state-peak)"
      />
    </svg>
  );
}
